import { initializeApp } from 'firebase/app';
import { getAuth } from 'firebase/auth';
import { getFirestore } from 'firebase/firestore';
import { getStorage } from 'firebase/storage';

const firebaseConfig = {
  apiKey: "AIzaSyCtPnu-WSXXqzZfWwfEBgIZuRx8KkElXTc",
  authDomain: "singvolve.firebaseapp.com",
  projectId: "singvolve",
  storageBucket: "singvolve.firebasestorage.app",
  messagingSenderId: "426926677495",
  appId: "1:426926677495:web:22841df96b12847966a2f2",
};

const app = initializeApp(firebaseConfig);
export const auth = getAuth(app);
export const db = getFirestore(app);
export const storage = getStorage(app);
export default app;
